import React from 'react'
import PropTypes from 'prop-types'
import {
  ImageContenFixedText,
  ImageContentFixedMain,
  ImageContentFixedMedia,
  ImageContentFixedWrapper,
} from './index.style'
import Container from '../Container'
import Grid from '../Grid'
import GridItem from '../GridItem'
import RichText from '../RichText'
import ImageLabel from '../ImageLabel'
import { GatsbyImage } from 'gatsby-plugin-image'
import ScrollSection from '../ScrollSection'
import Spacer from '../Spacer'
import AnimateScaleIn from '../animation/AnimateScaleIn'

const ImageContentFixed = ({
  id,
  content,
  linkId,
  alignLeft,
  image,
  background,
  color,
}) => (
  <ScrollSection>
    <ImageContentFixedMain bgColor={background} id={linkId}>
      <Container>
        <Grid>
          <GridItem
            tabletP={8}
            tabletPStart={3}
            tabletL={5}
            tabletLStart={alignLeft ? 2 : 8}
            tabletLOrder={alignLeft ? undefined : 2}
            desk={4}
            deskStart={alignLeft ? 2 : 8}
            deskOrder={alignLeft ? undefined : 2}
          >
            <ImageContenFixedText color={color}>
              <Spacer size={[90, 180]} />
              <RichText id={`${id}-content`} content={content} />
            </ImageContenFixedText>
          </GridItem>

          <GridItem
            tabletP={10}
            tabletPStart={2}
            tabletL={6}
            tabletLStart={alignLeft ? 7 : 1}
            tabletLOrder={alignLeft ? undefined : 1}
          >
            <Spacer size={[0, 90]} />
            <ImageContentFixedWrapper id={id}>
              <ImageContentFixedMedia
                alignLeft={alignLeft}
                data-scroll
                data-scroll-sticky
                data-scroll-target={`#${id}`}
              >
                <Spacer size={90} />
                <AnimateScaleIn
                  id={`${id}-fixed-image`}
                  position="relative"
                  borderRadius={true}
                >
                  <GatsbyImage
                    image={image.gatsbyImageData}
                    alt={image.description}
                  />
                </AnimateScaleIn>
                {image.title && (
                  <ImageLabel id={`${id}-label`} imageLabel={image.title} />
                )}
              </ImageContentFixedMedia>
            </ImageContentFixedWrapper>
          </GridItem>
        </Grid>
      </Container>

      <Spacer size={[90, 180]} />
    </ImageContentFixedMain>
  </ScrollSection>
)

ImageContentFixed.propTypes = {
  id: PropTypes.string,
  content: PropTypes.object,
  alignLeft: PropTypes.bool,
  image: PropTypes.object,
  background: PropTypes.string,
}

export default ImageContentFixed
